import React, {Component} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Container, Header, Segment, Image, Grid, Icon} from 'semantic-ui-react';
const coverImage = require('../assets/img/sky.jpeg');
const cupImage = require('../assets/img/cup.png');
const coverStyle = {
  backgroundColor: '#3D4751',
  backgroundImage: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed'
};
const mainSegmentStyle = {
  height: '70vh',
  background: 'rgba(0,0,0,0)',
  backgroundColor: 'hsl(0, 0%, 100%)',
  mixBlendMode: 'screen',
  marginBottom: '50vh'
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',

};
const textStyle = {
  fontSize: '16pt'
}
class ProductsView extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
        <Container fluid style={coverStyle}>
          <Segment size="massive" textAlign="center" basic className="coversegment">
            <Header as="h1" style={headerStyle}>
            <Header.Subheader style={subheaderStyle}>
                Un software de gestión ERP seguro y confiable para potenciar su empresa
              </Header.Subheader>
              Sistar
              
            </Header>
          </Segment>
          
          <Grid
            padded
            relaxed
            stackable
            style={{
            backgroundColor: 'white'
          }}>
          <Grid.Row columns={1}>
            <Grid.Column>
            <Header  color="grey" as="h2" textAlign="center" style={{color: 'white', fontSize: '5em'}}>
              Lo que tu empresa necesita
              <Header.Subheader style={{fontSize: "0.5em"}}>
                Crecer está a tu alcance
              </Header.Subheader>
            </Header>
            </Grid.Column>
          </Grid.Row>
            <Grid.Row columns={3} style={{padding: '30px'}}>
              <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="magic" color="yellow" />
                  Diseño intuitivo
                </Header>
              </Grid.Column>
              <Grid.Column>
                               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="exchange" color="blue" />
                  Aplicaciones ágiles y dinámicas 
                </Header>
              </Grid.Column>
              <Grid.Column>
                             <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="options" color="orange" />
                  Altamente parametrizable
                </Header>
              </Grid.Column>
            </Grid.Row>

          <Grid.Row columns={1} style={{marginTop: "30px"}}>
            <Grid.Column>
            <Header  color="grey" as="h2" textAlign="center" style={{color: 'white', fontSize: '5em'}}>
              Tranquilidad para producir
              <Header.Subheader style={{fontSize: "0.5em"}}>
                Todo está protegido
              </Header.Subheader>
            </Header>
            </Grid.Column>
          </Grid.Row>
            <Grid.Row columns={3} style={{padding: '30px'}}>
              <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="handshake" color="blue" />
                  Confiabilidad
                </Header>
              </Grid.Column>
              <Grid.Column>
                               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="lock" color="green" />
                  Seguridad
                </Header>
              </Grid.Column>
              <Grid.Column>
                             <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="fork" color="purple" />
                  Disponibilidad
                </Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={1}>
              <Grid.Column>

                <Segment size="massive" textAlign="center" basic>
                  <p style={{textAlign: "center"}}>
                   Especialmente diseñado para garantizar operatividad en organizaciones medianas y grandes, o en empresas con sucursales o puntos de venta distribuidos geográficamente con la mejor relación costo/beneficio del mercado.
                  </p>
                </Segment>
              </Grid.Column>
            </Grid.Row>
                      <Grid.Row columns={1} style={{marginTop: "30px"}}>
            <Grid.Column>
            <Header  color="grey" as="h2" textAlign="center" style={{color: 'white', fontSize: '5em'}}>
              Trabajamos con vos
              <Header.Subheader style={{fontSize: "0.5em"}}>
                Un servicio que se adapta a tu estructura y presupuesto
              </Header.Subheader>
            </Header>
            </Grid.Column>
          </Grid.Row>
            <Grid.Row columns={2} style={{padding: '30px'}}>
              <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="money" color="green" />
                  Compra
                  <Header.Subheader>
                    Hasta 12 cuotas
                  </Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="server" color="purple" />
                  Alquiler
                  <Header.Subheader>
                    Mensual
                  </Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column>
              </Grid.Column>
            </Grid.Row>


          </Grid>
                    <div style={{margin: '5px', textAlign: "center", color: "white"}}><strong>Teniente Cundom 1574 - Corrientes - Argentina</strong></div>
          
        </Container>
      
    );
  }
}

export default ProductsView;



// WEBPACK FOOTER //
// ./client/containers/ProductsView.js